module.exports = __webpack_public_path__ + "static/media/destination.97284145.png";